/* Adorable Bliss - "Try any 3" box builder (sections/ab-try-box.liquid).
   Fills a box from the scent cards (or the ready-made trio), then delegates
   to the theme:
     1. sets the theme's own scent dropdowns in .main-product
     2. waits until the theme has resolved the variant, and checks that its
        options are exactly the chosen scents and the form holds its id
     3. clicks the theme's own Add to cart button
   No cart write and no checkout link here; it only reads /cart.js to confirm
   the add. A mismatch never adds anything: the shopper sees a message, because
   a wrong set would be invisible until the parcel is opened. */
(function () {
  var WAIT_VARIANT_MS = 8000;
  var WAIT_CART_MS = 8000;

  function setup(root) {
    if (root.dataset.abTbReady) return;
    root.dataset.abTbReady = 'true';
    /* Only now hide the theme's product block: if this file never loads,
       the theme's dropdowns and button stay on the page and still work. */
    document.documentElement.classList.add('ab-tb-on');

    var d = root.dataset;
    var count = parseInt(d.count, 10);
    var picks = [];
    var busy = false;
    var all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var cards = all('[data-ab-tb-card]');
    var slots = all('[data-ab-tb-slot]');
    var counters = all('[data-ab-tb-counter]');
    var chips = all('[data-ab-tb-filter]');
    var emptyNames = slots.map(function (s) { return s.querySelector('[data-ab-tb-slot-name]').textContent; });
    var panel = root.querySelector('[data-ab-tb-panel]');
    var cta = root.querySelector('[data-ab-tb-cta]');
    var ctaLabel = root.querySelector('[data-ab-tb-cta-label]');
    var status = root.querySelector('[data-ab-tb-status]');
    var bar = root.querySelector('[data-ab-tb-bar]');
    var total = root.querySelector('[data-ab-tb-total]');
    var clear = root.querySelector('[data-ab-tb-clear]');
    var toggle = root.querySelector('[data-ab-tb-toggle]');
    var trio = root.querySelector('[data-ab-tb-trio]');
    cards.forEach(function (card) {
      var label = card.querySelector('[data-ab-tb-add-label]');
      label.dataset.label = label.textContent;
    });

    function fill(text, left) {
      return (text || '').replace(/\[left\]/g, left).replace(/\[added\]/g, picks.length);
    }

    function qtyOf(value) {
      return picks.filter(function (p) { return p.value === value; }).length;
    }

    function render(message) {
      var left = count - picks.length;
      var full = left === 0;

      cards.forEach(function (card) {
        var qty = qtyOf(card.dataset.value);
        var add = card.querySelector('[data-ab-tb-add]');
        var addLabel = card.querySelector('[data-ab-tb-add-label]');
        var stepper = card.querySelector('[data-ab-tb-stepper]');
        add.hidden = qty > 0;
        stepper.hidden = qty === 0;
        card.querySelector('[data-ab-tb-qty]').textContent = (d.textInBox || '[qty]').replace(/\[qty\]/g, qty);
        card.querySelectorAll('[data-ab-tb-plus]').forEach(function (b) { b.disabled = full || busy; });
        card.querySelector('[data-ab-tb-minus]').disabled = busy;
        addLabel.textContent = full && d.labelFull ? d.labelFull : addLabel.dataset.label;
        add.classList.toggle('is-full', full);
        card.classList.toggle('is-picked', qty > 0);
      });

      slots.forEach(function (slot, i) {
        var pick = picks[i];
        var thumb = slot.querySelector('[data-ab-tb-slot-thumb]');
        var name = slot.querySelector('[data-ab-tb-slot-name]');
        var x = slot.querySelector('[data-ab-tb-slot-x]');
        thumb.textContent = '';
        slot.classList.toggle('is-filled', !!pick);
        if (pick) {
          if (pick.img) {
            var img = document.createElement('img');
            img.src = pick.img;
            img.alt = '';
            thumb.appendChild(img);
          }
          name.textContent = pick.name;
          x.hidden = false;
          x.disabled = busy;
          x.setAttribute('aria-label', d.labelRemove + ' ' + pick.name);
        } else {
          name.textContent = emptyNames[i];
          x.hidden = true;
        }
      });

      counters.forEach(function (c) { c.textContent = fill(d.textCounter, left); });
      bar.style.width = (picks.length / count) * 100 + '%';
      if (total) total.textContent = full ? d.price : d.zero;
      if (clear) {
        clear.hidden = picks.length === 0;
        clear.disabled = busy;
      }
      if (trio) trio.disabled = busy;
      cta.disabled = !full || busy;
      cta.classList.toggle('is-locked', !full && !busy);
      if (busy) {
        ctaLabel.textContent = d.labelAdding;
      } else if (full) {
        ctaLabel.textContent = d.labelAdd + ' · ' + d.price;
      } else {
        ctaLabel.textContent = fill(d.labelMore, left);
      }
      panel.classList.toggle('is-full', full || busy);
      document.documentElement.classList.toggle('ab-tb-full', full || busy);
      status.textContent = message !== undefined ? message : full ? d.textFull : fill(d.textPick, left);
      status.classList.toggle('is-alert', message !== undefined && message !== d.textAdded);
      status.classList.toggle('is-done', message === d.textAdded);
    }

    function pickOf(card) {
      var img = card.querySelector('.ab-tb__photo img');
      return {
        value: card.dataset.value,
        name: card.dataset.name,
        img: img ? img.currentSrc || img.src : ''
      };
    }

    function add(card) {
      if (busy || picks.length >= count) return;
      picks.push(pickOf(card));
      render();
    }

    function removeLast(value) {
      for (var i = picks.length - 1; i >= 0; i--) {
        if (picks[i].value === value) {
          picks.splice(i, 1);
          return;
        }
      }
    }

    function theme() {
      var main = document.querySelector('.main-product');
      if (!main) return null;
      var picker = main.querySelector('.x-variant-picker');
      var form = main.querySelector('form[data-type="add-to-cart-form"]');
      if (!picker || !form) return null;
      return {
        picker: picker,
        idInput: form.querySelector('input[name="id"]'),
        button: main.querySelector('button[name="add"]')
      };
    }

    /* Marks all the choices first, then fires one change on the last dropdown:
       the theme reads every selected option, so this is one request, not three. */
    function setDropdowns(values) {
      var t = theme();
      if (!t) return false;
      var selects = Array.prototype.slice.call(t.picker.querySelectorAll('select'));
      if (selects.length !== values.length) return false;
      var found = selects.map(function (select, i) {
        return Array.prototype.filter.call(select.options, function (o) { return o.value === values[i]; })[0];
      });
      if (found.indexOf(undefined) !== -1) return false;
      selects.forEach(function (select, i) {
        Array.prototype.forEach.call(select.options, function (o) { o.removeAttribute('selected'); });
        found[i].setAttribute('selected', 'selected');
        select.selectedIndex = found[i].index;
      });
      selects[selects.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function readVariant(t) {
      var el = t.picker.querySelector('[data-selected-variant]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    function matches(variant, values) {
      if (!variant) return false;
      return values.every(function (value, i) { return variant['option' + (i + 1)] === value; });
    }

    function fail(message) {
      busy = false;
      render(message);
    }

    /* How many of this variant the cart holds. Read only. */
    function cartQty(variantId) {
      var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return cart.items.reduce(function (sum, item) {
            return item.variant_id === variantId ? sum + item.quantity : sum;
          }, 0);
        });
    }

    /* The theme's own events stop short if a later step throws (its openCart
       needs Shopflo's script to have loaded), so they only say "look now".
       The cart itself decides whether the box was added. */
    function clickAdd(variantId) {
      var t = theme();
      if (!t || !t.button || t.button.disabled) return fail(d.textError);
      cartQty(variantId).then(function (before) {
        var clearEvent = 'eurus:product-card:clear:' + d.productId;
        var timer;
        var settled = false;
        function settle() {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          document.removeEventListener(clearEvent, settle);
          document.removeEventListener('eurus:cart:items-changed', settle);
          cartQty(variantId).then(function (after) {
            if (after > before) {
              busy = false;
              picks = [];
              render(d.textAdded);
            } else {
              fail(d.textError);
            }
          }).catch(function () { fail(d.textError); });
        }
        document.addEventListener(clearEvent, settle);
        document.addEventListener('eurus:cart:items-changed', settle);
        timer = setTimeout(settle, WAIT_CART_MS);
        t.button.click();
      }).catch(function () { fail(d.textError); });
    }

    function addBox() {
      if (busy || picks.length !== count) return;
      var values = picks.map(function (p) { return p.value; });
      busy = true;
      render('');
      if (!setDropdowns(values)) return fail(d.textError);
      var started = Date.now();
      (function check() {
        var t = theme();
        var variant = t && readVariant(t);
        if (t && matches(variant, values)) {
          if (!variant.available) return fail(d.textUnavailable);
          if (t.idInput && String(t.idInput.value) === String(variant.id) && t.button && !t.button.disabled) {
            return clickAdd(variant.id);
          }
        }
        if (Date.now() - started > WAIT_VARIANT_MS) return fail(d.textError);
        setTimeout(check, 100);
      })();
    }

    /* Ready-made trio: replaces the box with its scents, then adds it the
       same way as a hand-picked box. */
    function addTrio() {
      if (busy) return;
      var names = (trio.dataset.names || '').split('|').filter(Boolean);
      var chosen = names.map(function (n) {
        return cards.filter(function (c) { return c.dataset.name.trim().toLowerCase() === n; })[0];
      });
      if (chosen.length !== count || chosen.indexOf(undefined) !== -1) return render(d.textError);
      picks = chosen.map(pickOf);
      render();
      addBox();
    }

    function filter(chip) {
      var fam = chip.dataset.abTbFilter;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      cards.forEach(function (card) { card.hidden = fam !== '' && card.dataset.family !== fam; });
    }

    root.addEventListener('click', function (e) {
      var target = e.target.closest('button');
      if (!target || !root.contains(target)) return;
      var card = target.closest('[data-ab-tb-card]');
      if (target.hasAttribute('data-ab-tb-plus')) {
        add(card);
      } else if (target.hasAttribute('data-ab-tb-minus')) {
        if (busy) return;
        removeLast(card.dataset.value);
        render();
      } else if (target.hasAttribute('data-ab-tb-slot-x')) {
        if (busy) return;
        picks.splice(slots.indexOf(target.closest('[data-ab-tb-slot]')), 1);
        render();
      } else if (target.hasAttribute('data-ab-tb-clear')) {
        if (busy) return;
        picks = [];
        render();
      } else if (target.hasAttribute('data-ab-tb-filter')) {
        filter(target);
      } else if (target.hasAttribute('data-ab-tb-trio')) {
        addTrio();
      } else if (target.hasAttribute('data-ab-tb-toggle')) {
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('ab-tb-open', open);
        target.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else if (target.hasAttribute('data-ab-tb-cta')) {
        addBox();
      }
    });

    render();
  }

  function init(scope) {
    scope.querySelectorAll('[data-ab-tb]').forEach(setup);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
